export default "__VITE_ASSET__9e1106be__"